module.exports = __webpack_public_path__ + "img/ep8-1d.5f803607.png";